import styled from 'styled-components';

import { IStyledUnitInputSingle, IStyledUnitInputSpan } from '../index';

export const StyledUnitSpan = styled.span<IStyledUnitInputSpan>`
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    padding-bottom: 5px;
    margin-left: 4px;
    ${({ theme, filled }) =>
        filled ? `color: ${theme['text-main']} !important` : `color: ${theme['text-secondary-subdued']}`};
`;

export const StyledLabelBox = styled.div<IStyledUnitInputSingle>`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    ${({ mb }) => `margin-bottom: ${mb || 48}px;`};
`;

export const StyledInput = styled.input<IStyledUnitInputSingle>`
    font-family: 'Roboto', sans-serif;
    width: 1ch;
    max-width: 99.99%;
    font-weight: 700;
    font-size: 48px;
    line-height: 56px;
    color: ${({ theme }) => theme['text-main']};
    background-color: transparent;
    outline: none;
    text-align: right;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
        display: none;
        -moz-appearance: textfield;
    }

    &:focus ~ ${StyledUnitSpan} {
        color: ${({ theme }) => theme['text-main']};
    }

    &::placeholder {
        color: ${({ theme }) => theme['text-secondary-subdued']};
    }

    &:focus::placeholder {
        opacity: 0;
    }
`;

export const StyledHintText = styled.div`
    position: absolute;
    width: 100%;
    top: 56px;
    left: 0;
`;
